import { render, staticRenderFns } from "./leftItem.vue?vue&type=template&id=0b402194"
import script from "./leftItem.vue?vue&type=script&lang=js"
export * from "./leftItem.vue?vue&type=script&lang=js"
import style0 from "./leftItem.vue?vue&type=style&index=0&id=0b402194&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports